import React, { useId } from 'react';
import { PARCEL_TYPES } from 'lib/format';
import { useLanguage } from 'lib/i18n';

export const ParcelTypeCheckboxes = ({ value = [], onChange, legend, testIdPrefix = 'trip-type' }) => {
  const id = useId();
  const { t } = useLanguage();
  return (
    <fieldset aria-describedby={`${id}-help`}>
      <legend className="text-sm font-medium">{legend}</legend>
      <p id={`${id}-help`} className="mt-1 text-xs text-muted-foreground">{t('trip.acceptedTypesHelp')}</p>
      <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3">
        {PARCEL_TYPES.map(parcelType => {
          const checked = value.includes(parcelType.value);
          return (
            <label key={parcelType.value} className={`flex min-h-11 cursor-pointer items-center gap-3 rounded-lg border px-3 py-2 text-sm transition-colors hover:border-primary ${checked ? 'border-primary bg-primary/5' : 'border-border bg-background'}`}>
              <input
                type="checkbox"
                name="accepted_parcel_types"
                value={parcelType.value}
                checked={checked}
                onChange={event => onChange(event.target.checked ? [...value, parcelType.value] : value.filter(item => item !== parcelType.value))}
                className="h-4 w-4 shrink-0 accent-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                data-testid={`${testIdPrefix}-${parcelType.value}-toggle`}
              />
              <span>{parcelType.label}</span>
            </label>
          );
        })}
      </div>
    </fieldset>
  );
};